/**
 * Los dos documentos que la persona acepta al registrarse y al postularse.
 *
 * Estaban repetidos en los cuatro formularios que los ofrecen, ocho veces en
 * total, y se actualizan cada tanto: cambiarlos obligaba a buscar y tocar
 * todos. Aquí viven una sola vez.
 *
 * `tipoDocumento` decide de dónde los lee ModalVisualizarDocumentos:
 *
 * - "terminos" y "politicasUso" van por consultarArchivosEstaticos, que lee
 *   la carpeta documentos/terminos horneada en la imagen del backend.
 * - Cualquier otro valor —"" entre ellos— va por consultarArchivo, que lee
 *   de uploads, que es donde quedan los archivos que se suben por el
 *   servicio de documentos.
 *
 * Para publicar una versión nueva se sube el PDF por el servicio, que
 * devuelve un nombre con su fecha dentro, y aquí se pone ese nombre con
 * `tipoDocumento: ""`. Es un cambio de dos líneas, en un solo archivo.
 */

export type DocumentoLegal = {
  nombre: string;
  tipoDocumento: string;
};

/**
 * Subidos el 16 de octubre de 2026 por el servicio de documentos. El nombre
 * lo pone él: lleva un identificador único y el año y mes, de donde después
 * saca la carpeta para encontrarlo.
 */
export const TERMINOS_Y_CONDICIONES: DocumentoLegal = {
  nombre: 'terminosycondicionespdf_culturadocykvmaimvbicdri_202610.pdf',
  tipoDocumento: '',
};

export const POLITICAS_DE_USO: DocumentoLegal = {
  nombre: 'politicasdeusopdf_culturadocykvmaimvbic6nj_202610.pdf',
  tipoDocumento: '',
};
